/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiListWorkspaceUserAdminEntitiesResponse,
  getCoinbaseEngUsersAccountManagementApiApiListWorkspaceUserAdminEntitiesResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiListWorkspaceUserAdminEntitiesResponse';

export type ListWorkspaceUserAdminEntitiesResult =
  CoinbaseEngUsersAccountManagementApiApiListWorkspaceUserAdminEntitiesResponse;

const validateListWorkspaceUserAdminEntitiesResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiListWorkspaceUserAdminEntitiesResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: ListWorkspaceUserAdminEntitiesResult data does not match contract.`,
      errors,
    );
  }
};

export const getListWorkspaceUserAdminEntitiesUrl = ({
  additionalParams,
  baseUrl,
}: {
  additionalParams?: Record<string, unknown>;
  baseUrl?: string;
} = {}) => {
  const searchParams = new URLSearchParams();
  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/workspace/admin-entities${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch ListWorkspaceUserAdminEntities
 * @Url /organization/v1/workspace/admin-entities
 * @Auth Required
 */

export function useGetListWorkspaceUserAdminEntities(
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): ListWorkspaceUserAdminEntitiesResult | undefined;

export function useGetListWorkspaceUserAdminEntities(
  options?: FetchOptions,
): ListWorkspaceUserAdminEntitiesResult;

export function useGetListWorkspaceUserAdminEntities(
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getListWorkspaceUserAdminEntitiesUrl(options);
  const data = useFetch<ListWorkspaceUserAdminEntitiesResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateListWorkspaceUserAdminEntitiesResult(data);
  }

  return data;
}

/**
 * Access ListWorkspaceUserAdminEntities fetch callback
 */
export const useGetListWorkspaceUserAdminEntitiesCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (additionalHeaders?: Record<string, string>) => {
      const url = getListWorkspaceUserAdminEntitiesUrl();
      const resource = getResource<ListWorkspaceUserAdminEntitiesResult>(
        url,
        undefined,
        additionalHeaders,
      );

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateListWorkspaceUserAdminEntitiesResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh ListWorkspaceUserAdminEntities without throwing to suspense
 * @Url /organization/v1/workspace/admin-entities
 * @Auth Required
 */
export const useRefreshListWorkspaceUserAdminEntities = (
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getListWorkspaceUserAdminEntitiesUrl();

  const { fetch } = useFetchableResource<ListWorkspaceUserAdminEntitiesResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove ListWorkspaceUserAdminEntities from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/workspace/admin-entities
 */
export const useClearListWorkspaceUserAdminEntities = () => {
  const url = getListWorkspaceUserAdminEntitiesUrl();

  const { clear } = useFetchableResource<ListWorkspaceUserAdminEntitiesResult>(url);

  return clear;
};

export const useWithOptimisticListWorkspaceUserAdminEntitiesUpdates = () => {
  const url = getListWorkspaceUserAdminEntitiesUrl();

  const { optimisticUpdate } = useFetchableResource<ListWorkspaceUserAdminEntitiesResult>(url);

  return optimisticUpdate;
};
